export class CommandCenterReportConfiguration {
	pk: string = "commandcenter"; //:commandCenter
	sk: string = "report_configuration"; //report_configuration
	reports: CommandCenterReport[];

	public constructor(init?: Partial<CommandCenterReportConfiguration>) {
		Object.assign(this, init);
	}
}

export class CommandCenterReport {
	name: string;
	description: string;
	key: string;
	category: string;
	accessLevel: number;
	optionDisabled: boolean;
	options: string[];
	icon: string;

	public constructor(init?: Partial<CommandCenterReport>) {
		Object.assign(this, init);
	}
}
